var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_908_842)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_908_842",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.851314 18.2966L18.5469 35.9922L36.5321 18.0069L18.8366 0.311374L0.851314 18.2966Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_908_842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6723 9.1471L27.7688 26.7702L25.2341 26.7945L25.4271 9.70236L27.6723 9.1471ZM26.7549 11.8026L10.5561 28.0014L8.81792 26.2632L25.0167 10.0644L26.7549 11.8026ZM27.6723 9.1471L27.1169 11.3921L10.025 11.5854L10.0733 9.07474L27.6723 9.1471Z",
    fill: "white",
    fillOpacity: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_908_842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.0693,
    height: 25.4778,
    fill: "white",
    transform: "translate(18.5703 36) rotate(-135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrow);
export default __webpack_public_path__ + "static/media/WhiteArrow.bef2d7f65b11ef727e81a5c2167fdb75.svg";
export { ForwardRef as ReactComponent };